<template>
  <div class="water-hazard">
    <the-top-bar title="Water Shortage Hazard Assessment" />
    <survey-overview @updateStep="$_goToSection" v-if="currentStep === 0" />
    <!--
    <div
      class="score-overview shadow-depth"
      id="v-step-1"
      :class="[scoreOverviewColorX]"
      v-if="false"
    >
      {{ impactLevel }}
    </div>
 -->
    <div v-if="currentStep === 1" style="padding: 0 0px 16px 0px">
      <div class="special-menu"></div>
      <div id="ess">
        <div class="row">
          <div class="col s12">
            <div class="card intro-card" v-if="calcToShow === 'essential'">
              <div class="card-content">
                <div class="tool-title">
                  Indoor Household Water Demand Calculator
                </div>
                <p class="styled">
                  Use the Indoor Household Water Demand Calculator provided to
                  estimate the amount of water your household would use over a
                  2-week period to meet all household needs, including essential
                  household needs (flushing toilets, showering, personal
                  hygiene, cleaning surfaces, cooking) and non-essential uses.
                </p>
                <p class="styled">
                  This demand will be compared against your available onsite
                  water storage capacity to determine the expected level of
                  impact to your household during a 2-week period without WASCO
                  supply, using the definitions provided in the
                  <a helper-id="C001" href="#">Expected Impact Level Chart</a>.
                </p>
                <p>
                  <em>
                    Note: Please complete the assessment even if you do not have
                    water storage tanks or a cistern at home to understand your
                    water demand and ideal water storage capacity.
                  </em>
                </p>
              </div>
            </div>

            <div class="note-card card" v-if="currentStep === 1 && calcToShow === 'essential'">
              <div class="card-content">
                <p class="styled">
                  If standard methods of calculation do not
                  apply (for example, internal plumbing is not
                  present), check the box below to apply
                  non-standard calculation. In the non-
                  standard mode, you will be able to
                  manually enter your household&#39;s total
                  water consumption for 2 weeks and explain
                  your assumptions/calculations in the space
                  provided. Be sure to account for the water
                  use of all persons living in your home and
                  for the full 14-day period.
                </p>
                <p>
                  <label>
                    <input type="checkbox" v-model="isNonStandard"
                      :disabled="isNonStandard ? nonStanEnable : stanEnable" />
                    <span>Apply non-standard calculation.</span>
                  </label>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="section-title" v-if="currentStep === 1 && calcToShow === 'essential'">
          Essential Household Needs
        </div>
        <essential-needs-calculator @standardEnable="$_setStan" v-if="currentStep === 1 && calcToShow === 'essential' && !isNonStandard
          " :data-value="secondForm.essential" @update="$_updateEssential" />
        <manual-entry-essential-needs-calculator @nonStandardEnable="$_setNonStan" v-if="currentStep === 1 && calcToShow === 'essential' && isNonStandard
          " :data-value="secondForm.manualEssential" @update="$_updateManualEssential" />
      </div>
      <div id="ness" v-if="currentStep === 1 && calcToShow === 'non-essential'">
        <div class="section-title">
          Non-essential Uses - Running of Appliances
        </div>
        <non-essential-needs-calculator ref="nonCalc" :data-value="secondForm.nonEssential"
          @update="$_updateNonEssential" />
        <div class="floating-action-button" @click="$refs.nonCalc.$_openModal()"
          v-if="currentStep === 1 && calcToShow === 'non-essential'">
          <button class="btn btn-rounded indigo accent-2">
            <i class="large material-icons white-text left">add</i> ADD AN
            APPLIANCE
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="app-padding">
        <form-builder ref="loanForm" :schema="schema" v-model="form" :stepper-data="stepper" @status="saveStatus"
          @stepStatus="updateStepStatus" :current-step="currentStep" isStepper v-if="ready && currentStep > 0" />
      </div>
    </div>
    <water-supply v-if="currentStep === 3" @update="$_updateTotalWaterStorage" />
    <div class="control-bar z-depth-1 row" v-if="currentStep > 0">
      <button class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2" @click="$_customBackEvent()">
        Back
      </button>
      <router-link :to="{ name: 'Home' }" class="btn waves-effect btn-rounded col s5 m2 right"
        style="background:#5374F8; color:#fff;" v-if="currentStep === 4">
        Finish
      </router-link>

      <button class="btn waves-effect btn-rounded col s5 m2 right" style="background:#5374F8; color:#fff;"
        :class="[status.invalid ? 'disabled' : 'shadow-depth']" @click="$_goTo()" v-if="currentStep < 4">
        Next
      </button>
    </div>
    <app-bottom-tab v-else />
    <final-step v-if="currentStep === 4" :data-impact-level="impactLevel" @updateSelectedScore="$_updateScore"
      :dataSelectedScore="waterHazardSurvey ? waterHazardSurvey.score : {}" dataSurvey="water_survey" />
  </div>
</template>

<script>
import FormBuilder from "@/components/formBuilder/FormBuilder.vue";
import { schema } from "@/schemas/waterHazard.js";
import TheTopBar from "@/components/TheTopBar";
import waterSupply from "@/components/WaterSurvey/waterSupply.component";
import { mapActions, mapState } from "vuex";
import FinalStep from "@/components/TheSurveyFinalStep";
import { setDocumentBodyOverflowProperty } from "@/common/util";
import AppBottomTab from "@/components/AppBottomTab";
import TheSurveysTour from "@/components/TheSurveysTour";
import EssentialNeedsCalculator from "@/components/EssentialNeedsCalculator";
import NonEssentialNeedsCalculator from "@/components/NonEssentialNeedsCalculator";
import SurveyOverview from "@/components/WaterSurvey/SurveyOverview";
import ManualEntryEssentialNeedsCalculator from "@/components/ManualEntryEssentialNeedsCalculator";
export default {
  name: "WaterHazardSurvey",
  components: {
    FormBuilder,
    TheTopBar,
    FinalStep,
    TheSurveysTour,
    waterSupply,
    EssentialNeedsCalculator,
    NonEssentialNeedsCalculator,
    AppBottomTab,
    SurveyOverview,
    ManualEntryEssentialNeedsCalculator,
  },
  data() {
    return {
      schema,
      ready: false,
      status: {
        invalid: false,
      },
      nonStanEnable: false,
      stanEnable: true,
      tabs: {
        instance: null,
        options: {},
      },
      stepper: {
        stepStatus: false,
        canPrev: false,
        canNext: false,
      },
      secondForm: {
        essential: {},
        nonEssential: {},
        manualEssential: {},
        grandTotal: 0,
      },
      totalWaterStorage: 0,
      form: {},
      currentStep: 0,
      impactLevel: "",
      shouldSave: false,
      userSelectedScore: "",
      userJustification: "",
      tagId: 40,
      section: "",
      calcToShow: "essential",
      isNonStandard: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "WaterHazard" &&
      this.$store.state.Surveys.waterHazardStarted
    ) {
      next({ name: "Home" });
    }
    next();
  },
  created() {
    // Redirect user to survey start page if user hasnt started survey
    if (!this.$store.state.Surveys.waterHazardStarted) {
      this.$router.push({ name: "WaterHazard" });
    }
  },

  mounted() {
    // this.$_getStepFromUrl();
    this.$_getData();
  },
  watch: {
    calcToShow: function (nV) {
      // console.log(nV  )
      if (nV === "essential") {
        setTimeout(() => {
          this.$_setupHelpers();
        }, 100);
      }
    },
    $route: function (nV) {
      if ((nV && !nV.query) || (nV && !nV.query.editing)) {
        this.$_goTo(1);
      } else if (nV && nV.query.editing) {
      }
      if (this.$route.query.step) {
        this.currentStep = parseFloat(this.$route.query.step);
      }
    },
    currentStep: function (nV, oV) {
      nV < 1 && this.$route.query.editing
        ? this.$router.replace({ query: {} })
        : "";
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
  },
  computed: {
    ...mapState({
      showTour: (state) => state.Surveys.showSurveyTour,
      waterHazardSurvey: (state) => state.Surveys.waterHazard,
      waterHazardStarted: (state) => state.Surveys.waterHazardStarted,
      user: (state) => state.User.user,
    }),
    $_handleManualEntry() {
      this.isManualEntry = true;
    },
    scoreOverviewColorX() {
      switch (this.impactLevel) {
        case "Minor":
          return "light-blue-text lighten-3";
        case "Moderate":
          return "amber-text lighten-2";
        case "Major":
          return "orange-text lighten-3";
        case "Extreme":
          return "red-text lighten-3";
        default:
          return "black-text";
      }
    },
    surveyDataX() {
      return {
        survey: Object.assign({}, { ...this.secondForm, ...this.form }),
        isNonStandard: this.isNonStandard,
        score: {
          generated: this.impactLevel,
          selected: this.userSelectedScore,
          justification: this.userJustification,
        },
        totalWaterStorage: this.totalWaterStorage,
        assessment:
          this.waterHazardSurvey && this.waterHazardSurvey.assessment
            ? this.waterHazardSurvey.assessment
            : {},
      };
    },
  },
  methods: {
    ...mapActions("Surveys", {
      setShowSurveyTour: "SET_SHOW_SURVEY_TOUR",
      updateSurvey: "UPDATE_WATER_HAZARD",
    }),
    $_setNonStan(val) {
      this.nonStanEnable = val;
    },
    $_setStan(val) {
      this.stanEnable = val;
    },
    $_customBackEvent() {
      let groupedActions = () => {
        this.calcToShow = "non-essential";
        this.currentStep -= 1;
      };
      this.calcToShow === "non-essential" && this.currentStep === 1
        ? (this.calcToShow = "essential")
        : this.currentStep === 2 && this.calcToShow === "essential"
          ? groupedActions()
          : (this.currentStep -= 1);
    },
    $_initTabs() {
      setTimeout(() => {
        this.tabs.instance = M.Tabs.init(this.$refs.tabs, this.tabs.options);
      }, 100);
    },
    $_updateTotalWaterStorage(val) {
      this.totalWaterStorage = val;
      this.$_generateImpactLevel();
      this.shouldSave = true;
    },
    $_updateEssential(val) {
      this.$set(this.secondForm, "essential", val);
      this.$_calculateGrandTotal(
        this.secondForm.essential.subTotal,
        this.secondForm.nonEssential.subTotal
      );
      this.$_generateImpactLevel();
      this.shouldSave = true;
    },
    $_updateManualEssential(val) {
      this.$set(this.secondForm, "manualEssential", val);
      this.$_calculateGrandTotal(
        this.secondForm.manualEssential.subTotal,
        this.secondForm.nonEssential.subTotal
      );
      this.$_generateImpactLevel();
      this.shouldSave = true;
    },
    $_updateNonEssential(val) {
      this.$set(this.secondForm, "nonEssential", val);

      this.$_calculateGrandTotal(
        this.secondForm.essential.subTotal,
        val.subTotal
      );

      this.$_generateImpactLevel();
      this.shouldSave = true;
    },
    $_generateImpactLevel() {
      if (parseFloat(this.totalWaterStorage) < 1) {
        this.impactLevel = "Extreme Impact";
        return;
      }
      if (
        parseFloat(this.secondForm.essential.subTotal) >
        parseFloat(this.totalWaterStorage)
      ) {
        this.impactLevel = "Major Impact";
        return;
      } else {
        if (
          parseFloat(this.secondForm.grandTotal) <=
          parseFloat(this.totalWaterStorage)
        ) {
          this.impactLevel = "Minor Impact";
          return;
        }

        this.impactLevel = "Moderate Impact";
        return;
      }
    },
    $_calculateGrandTotal(a, b) {
      let val = parseFloat(a) + parseFloat(b);
      val = val.toFixed(2);
      this.$set(this.secondForm, "grandTotal", val);
    },

    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");
      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault();
            const helperId = helperEl.getAttribute("helper-id");
            this.$store.dispatch("Helpers/setHelper", helperId);
          });
        });
      }
    },
    $_updateScore(val) {
      this.userSelectedScore = val.selected;
      this.userJustification = val.justification;

      this.$_saveData();
    },
    $_getData() {
      if (this.waterHazardSurvey) {
        if (this.waterHazardSurvey.survey) {
          this.secondForm = this.waterHazardSurvey.survey;
          this.form = this.waterHazardSurvey.survey;
        }
        if (this.waterHazardSurvey.score) {
          this.userSelectedScore = this.waterHazardSurvey.score.selected;
          this.userJustification = this.waterHazardSurvey.score.justification;
        }
        if (this.waterHazardSurvey.totalWaterStorage)
          this.totalWaterStorage = this.waterHazardSurvey.totalWaterStorage;
        this.isNonStandard = !!this.waterHazardSurvey.isNonStandard;
      }
      if (this.$route.query && this.$route.query.step)
        this.currentStep = parseInt(this.$route.query.step);
      this.ready = true;

      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_goToSection({ step, section }) {
      this.currentStep = step;
      this.section = section;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_endTour() {
      this.setShowSurveyTour(false);
      setDocumentBodyOverflowProperty("auto");
    },

    $_goTo(step = null) {
      if (this.shouldSave) this.$_saveData();
      if (step) {
        this.currentStep = 0;
      } else {
        if (this.section === "indoor" && this.calcToShow === "essential")
          this.calcToShow = "non-essential";
        else if (
          this.section === "indoor" &&
          this.calcToShow === "non-essential"
        ) {
          this.currentStep = 2;
          this.section = "water";
        } else this.currentStep += 1;

        this.$router.push({
          query: {
            editing: true,
            section: this.currentStep,
            step: this.currentStep,
          },
        });
        setTimeout(() => {
          this.$_setupHelpers();
        }, 300);
      }
      window.scrollTo(0, 0);
    },
    saveStatus(status) {
      Object.assign(this.status, status);
      this.$_generateImpactLevel();
      // this.getImpactLevel();
    },
    submit() {
      this.$refs.loanForm.validate();
      if (this.status.invalid) return;
    },
    updateStepStatus(stepInfo) {
      Object.assign(this.stepper, stepInfo);
      if (!stepInfo.isInitializing) this.shouldSave = true;
    },
    getImpactLevel() {
      // this.impactLevel = impactLevelGenerator(this.schema, this.form);
    },
    $_next(step) {
      if (step === "final") {
        this.$_saveData();
      }
      if (step === "finish") {
        this.$router.push({ name: "Home" });
      }
      this.currentStep++;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_prev() {
      this.currentStep--;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_saveData() {
      // if (this.waterHazardSurvey) {
      //   if (this.waterHazardSurvey.id) {
      //     this.surveyDataX.id = this.waterHazardSurvey.id;
      //   }
      // }

      this.updateSurvey(this.surveyDataX);
      // this.shouldSave = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-action-button {
  position: fixed;
  z-index: 9;
  bottom: 80px;
  right: 90px;
}

.tool-title {
  font-size: 26px;
  position: relative;
}

.water-hazard {
  padding-bottom: 68px;

  .control-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    padding: 1rem;
    margin: 0 !important;
    background: #fff;
    z-index: 900;
  }

  .section-title {
    font-size: 24px;
    padding: 16px;
  }
}

.tabs-wrapper {
  position: relative;
  width: 100%;
  z-index: 9;
  height: 48px;

  .tabs {
    position: fixed;
    top: 48px;
    width: 100%;
  }
}

.app-padding {
  padding: 16px 24px 0 24px;

  @media screen and (min-width: 1024px) {
    max-width: 768px;
    margin: auto;
  }
}

#ess {
  max-width: 768px;
  margin: auto;
}

#ness {
  max-width: 768px;
  margin: auto;
}

.card {
  &.intro-card {
    background-color: #fbd15e;
    margin-top: 18px;
  }

  .card-content {
    p {
      &.styled {
        margin: 0px 0 12px 0px;
      }
    }
  }
}
</style>
<style lang="scss">
.water-hazard {
  .section-head {
    font-size: 32px;
    font-family: "Libre Franklin", sans-serif;
    line-height: 34px;
    font-weight: 600;
    color: #f6be22;
  }
}
</style>
